import { render, staticRenderFns } from "./PricingPaymentMethods.vue?vue&type=template&id=004b8937&scoped=true&"
import script from "./PricingPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./PricingPaymentMethods.vue?vue&type=script&lang=js&"
import style0 from "./PricingPaymentMethods.vue?vue&type=style&index=0&id=004b8937&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004b8937",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect,VSwitch,VTextField})
